import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Image } from "../../components/models/image.ts";
import { IdentityDocument } from "../../components/models/identity-document.ts";
import { DocumentStatus } from "../../components/models/identity-document.enum.ts";

interface DraftDocument {
  _id: string;
  status: DocumentStatus; // Change this to match the enum
  _subtype: string;
  _type: string;
}

export interface IdentityDocCaptureState {
  docCaptureModalOpen: boolean;
  draftDocument: DraftDocument;
  getDocumentCollector: any;
  documentImages: any;
  selfieImage: any;
  attachDocument: Image[];
  identityDocument: IdentityDocument;
  identityDocumentForced: IdentityDocument;
  selectedIDDocument: any;
  error: any;
  endpointLoading: any;
  documentSubmitted: boolean;
  nonIDModalOpen: boolean;
  uploadedDocs?: DocumentCollector[];
  submittedIDs?: any;
  mobileHandOff: boolean;
  forcedSubmit: boolean;
  isDocumentStored: boolean;
}

const initialState: IdentityDocCaptureState = {
  docCaptureModalOpen: false,
  draftDocument: {
    _id: "",
    status: 0,
    _subtype: "",
    _type: "",
  },
  documentImages: [],
  selfieImage: [],
  getDocumentCollector: {},
  attachDocument: [],
  selectedIDDocument: null,
  nonIDModalOpen: false,
  identityDocument: {},
  identityDocumentForced: {},
  error: {},
  endpointLoading: false,
  documentSubmitted: false,
  uploadedDocs: [],
  submittedIDs: [],
  forcedSubmit: false,
  mobileHandOff: false,
  isDocumentStored: false
};

export const identityDocCaptureSlice = createSlice({
  name: "identity_doc_capture",
  initialState,
  reducers: {
    addIdentityDoc: (state, action) => {
      if (state?.uploadedDocs?.length === 0) {
        state.uploadedDocs = [action.payload];
      } else {
        const isDocAlreadyUploaded = state.uploadedDocs?.some(
          (doc) => doc._id === action.payload._id
        );
        if (!isDocAlreadyUploaded) {
          state.uploadedDocs = [...state.uploadedDocs!, action.payload];
        } else {
          state.uploadedDocs = state.uploadedDocs?.map((doc) =>
            doc._id === action.payload._id ? action.payload : doc
          );
        }
        // state.uploadedDocs = state.uploadedDocs?.map((doc) =>
        //   doc._id === action.payload._id ? action.payload : doc
        // );
      }
    },
    removeIdentityDoc: (state, action) => {
      state.uploadedDocs = state.uploadedDocs?.filter(
        (doc) => doc._id !== action.payload._id
      );
    },
    clearIdDocs: (state) => {
      state.uploadedDocs = [];
    },
    setDocCaptureData: (
      state,
      action: PayloadAction<Partial<IdentityDocCaptureState>>
    ) => {
      // Only update the fields provided in the action payload
      Object.assign(state, action.payload);
    },
  },
});

export const {
  setDocCaptureData,
  addIdentityDoc,
  removeIdentityDoc,
  clearIdDocs,
} = identityDocCaptureSlice.actions;
export default identityDocCaptureSlice.reducer;
